<template>
	<div >
		<div class="pd10">
			<a-spin :spinning="loading">
				<div class="form-search-box ">
					<a-form layout="inline">
						<a-form-item label="名称">
							<a-input v-model="search.name" placeholder="请输入商品名称"></a-input>
						</a-form-item>
						
						<a-form-item label="第一分类">
							 <a-select v-model="search.pid" style="width: 200px" @change="handleChange">
								 <a-select-option :value="0" >
								   请选择
								 </a-select-option>
							      <a-select-option :value="item.category_id" v-for="(item,index) in first_type_list">
							        {{item.name}}
							      </a-select-option>
							 </a-select>
						</a-form-item>
						
						<a-form-item label="第二分类" v-if="search.pid!=0">
							 <a-select v-model="search.category_id" style="width: 200px">
								 <a-select-option :value="0" >
								   请选择
								 </a-select-option>
							      <a-select-option :value="item.category_id" v-for="(item,index) in second_type_list">
							        {{item.name}}
							      </a-select-option>
							 </a-select>
						</a-form-item>
						
						<a-form-item>
							<a-button @click="searchAct" type="primary">查询</a-button>
							<a-button @click="cancelAct" class="ml10">取消</a-button>
						</a-form-item>
					</a-form>
				</div>
				
				<div class=" pd20">
					<div class="flex wrap" v-if="getDatas.length>0">
						<template v-for="(item,index) in getDatas">
							<div class="goods-data-item" :class="{active : item.is_select==1}" >
								<img v-if="item.cover_img" :src="item.cover_img" class="goods-data-item-cover-img"/>
								<img v-else src="../../../../../assets/image/41f5d53f5e9c32b4.jpg" class="goods-data-item-cover-img"/>
								<div class="pd10">
									<div class="ft12 ftw400 cl-black text-over4">{{item.name}}</div>
									<div class="flex alcenter space mt10" v-if="item.is_select==1">
										<div class="cl-price ft14">￥{{item.original_price}}</div>
										<div class="choose-button" v-if="item.is_have_sku==1" @click="chooseSkuAct(index)">规格</div>
										<div class="choose-button" v-else >选择</div>
									</div>
									<div class="flex alcenter space mt10" v-else>
										<div class="cl-price ft14">￥{{item.original_price}}</div>
										<div class="choose-button" v-if="item.is_have_sku==1" @click="chooseSkuAct(index)">规格</div>
										<div class="choose-button" v-else  @click="chooseIt(index)">选择</div>
									</div>
								</div>
								<div class="goods-data-item-choose flex alcenter center" v-if="item.is_select==1">
									<i class="iconfont iconyes ft28 cl-green"/>
								</div>
								
								<div class="goods-data-item-quota">库存：{{item.quota}}</div>
							</div>
						</template>
					</div>
					
					<div class="mt20 flex center" v-else>
						<a-empty/>
					</div>
								
					<div class="flex center mt20">
						<a-pagination @change="pageChange" :total="pagination.total" v-model="pagination.current" :pageSize="pagination.pageSize" show-less-items />
					</div>
					
					<div v-if="chooseSkuVisible">
						<choose-sku :visible="chooseSkuVisible" :goods="goods" @cancel="cancelChooseSku" @ok="okChooseSku"></choose-sku>
					</div>
				</div>
			</a-spin>
		</div>
	</div>
</template>

<script>
	import {listMixin} from '../../../../../common/mixin/list.js';
	import chooseSku from './goods/modal/sku.vue';
	export default{
		mixins:[listMixin],
		components:{
			chooseSku,
		},
		data(){
			return{
				loading:false,
				chooseSkuVisible:false,
				goods:{},
				pagination: {
					current: 1,
					pageSize: 8, //每页中显示10条数据
					total: 0,
				},
				search:{
					name:'',
					pid:0,
					category_id:0,
				},
				type_list:[],
				datas:[],
			}
		},
		created() {
			
		},
		computed:{
			first_type_list(){
				let arr = new Array;
				for( var i in this.type_list){
					if(this.type_list[i].pid==0){
						arr.push(this.type_list[i]);
					}
				}
				return arr;
			},
			
			second_type_list(){
				let arr = new Array;
				if(this.search.pid !=0){
					for( var i in this.type_list){
						if(this.type_list[i].pid==this.search.pid){
							arr.push(this.type_list[i]);
						}
					}
				}
				return arr;
			},
			
			getDatas(){
				let datas =JSON.parse(JSON.stringify(this.datas));
				for(var i in datas){
					let vip_level=0;
					if(JSON.stringify(this.cashierMember)!='{}'){
						if(this.cashierMember.level != null){
							console.log(this.cashierMember.level);
							vip_level=this.cashierMember.level.vip_level;
						}
					}
					let vip_price=0;
					if(vip_level==1){
						vip_price=datas[i].vip1_price;
					}else if(vip_level==2){
						vip_price=datas[i].vip2_price;
					}else if(vip_level==3){
						vip_price=datas[i].vip3_price;
					}else if(vip_level==4){
						vip_price=datas[i].vip4_price;
					}else if(vip_level==5){
						vip_price=datas[i].vip5_price;
					}else{
						vip_price=datas[i].vip1_price;
					}
					if(datas[i].only_one_vip==0){
						datas[i].vip_price=vip_price;
					}
					//规格
					if(datas[i].sku){
						for(var k in datas[i].sku){
							let sku_vip_price=0;
							if(vip_level==1){
								sku_vip_price=datas[i].sku[k].vip1_price;
							}else if(vip_level==2){
								sku_vip_price=datas[i].sku[k].vip2_price;
							}else if(vip_level==3){
								sku_vip_price=datas[i].sku[k].vip3_price;
							}else if(vip_level==4){
								sku_vip_price=datas[i].sku[k].vip4_price;
							}else if(vip_level==5){
								sku_vip_price=datas[i].sku[k].vip5_price;
							}else{
								sku_vip_price=datas[i].sku[k].vip1_price;
							}
							if(datas[i].only_one_vip==0){
								datas[i].sku[k].vip_price=sku_vip_price;
							}
						}
					}
					
					for(var j in this.cashierCart){
						if(this.cashierCart[j].type=='goods'){
							if(this.cashierCart[j].goods_id==datas[i].goods_id){
								datas[i].is_select=1;
							}
						}
					}
				}
				return datas;
			}
		},
		methods:{
			
			getLists(){
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('getGoodsList',{
					limit:this.pagination.pageSize,
					page:this.pagination.current,
					name:this.search.name,
					category_id:this.search.category_id,
				}).then(res=>{
					this.pagination.total=res.total;
					this.datas=res.list;
					if(res.type_list){
						this.type_list=res.type_list;
					}
					this.loading=false;
				}).catch(res=>{
					this.loading=false;
				})
			},
			
			handleChange(){
				this.search.category_id=0;
			},
			
			chooseIt(index){
				let cart=JSON.parse(JSON.stringify(this.cashierCart));
				for(var i in cart){
					if(cart[i].type=='goods'){
						if(this.datas[index].goods_id == cart[i].goods_id){
							return false;
						}
					}
				}
				
				cart.push({
					goods_id:this.getDatas[index].goods_id,
					num:1,
					type:'goods',
					name:this.getDatas[index].name,
					cover_img:this.getDatas[index].cover_img,
					original_price:this.getDatas[index].original_price,
					only_one_vip:this.getDatas[index].only_one_vip,
					vip_price:this.getDatas[index].vip_price,
					vip1_price:this.getDatas[index].vip1_price,
					vip2_price:this.getDatas[index].vip2_price,
					vip3_price:this.getDatas[index].vip3_price,
					vip4_price:this.getDatas[index].vip4_price,
					vip5_price:this.getDatas[index].vip5_price,
					sku_id:0,
					quota:this.getDatas[index].quota,
				});
				this.$store.commit('setCashierCart',cart);
			},
			chooseSkuAct(index){
				 this.goods=this.getDatas[index];
				 this.chooseSkuVisible=true;
			 },
			 cancelChooseSku(){
				 this.chooseSkuVisible=false;
			 },
			okChooseSku(){
			 	this.chooseSkuVisible=false;
				this.getLists();
			 },
		},
		 
	}
</script>

<style>
	.goods-data-item{
		width: 24%;
		height: 250px;
		margin-right: 1%;
		margin-bottom: 1%;
		border: 1px solid #F4F5F7;
		box-shadow:0px 15px 10px -15px #000;
		line-height: 1;
		position: relative;
	}
	
	.goods-data-item.active{
		border: 1px solid #00C657;
	}
	
	.goods-data-item-choose{
		position: absolute;
		top:0;
		left: 0;
		width: 100%;
		height: 180px;
	}
	.goods-data-item-quota{
		position: absolute;
		top:0;
		right: 0;
		padding: 4px 8px;
		background: #F56C6C;
		color: #FFFFFF;
		border-radius: 4px;
	}
	
	.goods-data-item-cover-img{
		width: 100%;
		height: 180px;
	}
	
	.choose-button{
		padding: 8px 14px;
		background: #4772FF;
		color: #ffffff;
		border-radius: 4px;
	}
</style>
